export const CartSymbols = {
    CartService: Symbol.for("CartService"),
    CartProvider: Symbol.for("CartProvider")
}